module.exports = __webpack_public_path__ + "img/soccerboard98.055d3ba3.jpg";